<template>
	<v-container grid-list-xl>
		<v-layout row wrap>
		    <v-flex lg12 class="headerholder">
              <v-data-table ref="sortableTable" :items="soColumns" hide-actions class="elevation-1 fullHeight" disable-initial-sort :rows-per-page-items="[20,40,60,80,100]">
                <template slot="items" slot-scope="props">
                 <tr class="sortableRow" id="rows">
                    <td width="5%" class="px-1">
                      <v-btn style="cursor: move" icon class="sortHandle"><v-icon>drag_handle</v-icon></v-btn>
                    </td>
                    <td width="15%"><v-switch v-model="props.item.checked"></v-switch></td>
                    <td width="40%" v-if="!fncCheckNumber(props.item.id)">{{ props.item.label }}</td>
                    <td width="40%" v-if="fncCheckNumber(props.item.id)">
                      <v-select label="Select Column Role" @input="fncSetId(props.item)" style="width:87%;display:block;float:left;margin-top: 0px !important;" v-model="props.item.id" item-value="id" :items="vendorRoles" item-text="name" solo outline autocomplete></v-select>
                    </td>
                    <td width="40%" class="text-xs-right"><v-select v-model="props.item.width" item-value="id" :items="columnWidths" autocomplete solo></v-select></td>
                  </tr>
                </template>
              </v-data-table>
          <!--<v-btn @click="fndAddRoleColumn">Add Role Column</v-btn>-->
			</v-flex>
			<div class="pl-4 pr-1 pb-4 buttonHolder">
				<div style="float: right">
					<v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Close</v-btn>
					<v-btn class="text-xs-right cancelButton" @click.stop="fncSaveSettings">Update</v-btn>
				</div>
			</div>
		</v-layout>
	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex';
	//import draggable from 'vuedraggable'
    import Sortable from 'sortablejs';
	export default {
	  name: 'Settings',
      data() {
        return {
          vendorRoles: [],
                //objQuoteSettings: this.$store.getters.objQuoteSettings,
                columnWidths: [
                  { id: 'auto', text: 'Auto Fit' },
                  { id: '100px', text: '100px' },
                  { id: '200px', text: '200px' },
                  { id: '300px', text: '300px' },
                  { id: '400px', text: '400px' },
                  { id: '500px', text: '500px' },
                ],
                row: ['order']
                //soSettings: JSON.parse(window.localStorage.soColumns)
			};
		},
		methods: {
      fncSetId(index) {

        var setIndex = ( index.order ) - 1;
        if( ( index.order + 1 ) == this.soColumns.length ) { console.log('LAST ITEM'); setIndex = index.order; }

        for( var r in this.userRoles ) {
          if( this.vendorRoles[r].id == index.id ) {
            this.soColumns[setIndex].label = this.vendorRoles[r].name;
          }
        }
        this.fncCustomReorder();
      },
      fncCheckNumber(value) {
        if (isNaN(value) ) {
          return false;
        } else {
          return true;
        }
      },
      fndAddRoleColumn(){
        var toPush = { checked: true, id: '', label: '', order: this.soColumns.length, width: 'auto' };
        this.soColumns.push( toPush );
      },
			fncHideModal () {
				this.$store.commit('hideModal');
			},
            fncReorderQuoteColumns({ oldIndex, newIndex }) {
              this.$store.commit({
                type: 'fncResetSoColumns',
                start: oldIndex,
                end: newIndex
              });
              this.$store.commit('emptySoColumns');
              this.$store.commit('fncSetSalesOrderColumns', this.objAuthorize);
              this.$store.commit('fncEmptySalesOrders');
              this.$store.dispatch('fncPopulateSalesOrders', false);
              var snackDetails = { color: 'success', message: 'Purchase Order Report columns have been updated', display: true };
              this.$store.commit('setSnack', snackDetails);
            },
            fncSaveSettings() {

              this.$store.dispatch('fncSaveSalesOrderColumns', this.objAuthorize.id);

              /*this.$store.commit({
                type: 'fncResetSoColumns',
                data: this.soColumns
              });
              var snackDetails = { color: 'success', message: 'Purchase Order Report columns have been updated', display: true };
              this.$store.commit('setSnack', snackDetails);
              this.$store.commit('fncEmptySalesOrders');
              this.$store.dispatch('fncPopulateSalesOrders', false);*/
            }
		},
		computed: {
			...mapGetters([
				'objAuthorize',
				'globalModalParams',
				'soColumns',
        'userRoles'
			])
		},
		 components: {
           Sortable
        },
        mounted() {
	        if( this.userRoles.length > 0 ) {
            this.vendorRoles = [];
            if( this.userRoles.length > 0 ) {
              for( var u in this.userRoles ) {
                if( this.userRoles[u].user_type == 6 ) {
                  this.vendorRoles.push(this.userRoles[u]);
                }
              }
            }
          }
          new Sortable(
            this.$refs.sortableTable.$el.getElementsByTagName('tbody')[0],
            {
              draggable: '.sortableRow',
              handle: '.sortHandle',
              onUpdate: this.fncReorderQuoteColumns
            }
          )

        },
    beforeMount(){
      this.$store.dispatch('fncPopulateRoles');
    },
    watch: {
      userRoles() {
        this.vendorRoles = [];
        if( this.userRoles.length > 0 ) {
          for( var u in this.userRoles ) {
            if( this.userRoles[u].user_type == 6 ) {
              this.vendorRoles.push(this.userRoles[u]);
            }
          }
        }
      }
    }
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>
